import { render, staticRenderFns } from "./satellite.vue?vue&type=template&id=93cb214e&scoped=true&"
import script from "./satellite.vue?vue&type=script&lang=js&"
export * from "./satellite.vue?vue&type=script&lang=js&"
import style0 from "./satellite.vue?vue&type=style&index=0&id=93cb214e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cb214e",
  null
  
)

export default component.exports